export default "__VITE_ASSET__DgHMlN9y__"